import { render, staticRenderFns } from "./PlanLoadingExtension.vue?vue&type=template&id=8f8cc3f6&scoped=true"
import script from "./PlanLoadingExtension.vue?vue&type=script&lang=js"
export * from "./PlanLoadingExtension.vue?vue&type=script&lang=js"
import style0 from "./PlanLoadingExtension.vue?vue&type=style&index=0&id=8f8cc3f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8cc3f6",
  null
  
)

export default component.exports